<template>
  <div class="videoExamine-box">
    <el-form ref="params" :model="params" label-width="auto">
      <el-row :gutter="5">
        <el-col :span="6">
          <el-form-item label="付费类型" style="margin-bottom: 0">
            <el-select
              v-model="params.isFree"
              placeholder="是否付费"
              style="width: 100%"
              size="small"
              @change="getVideoList('status')"
              clearable
            >
              <el-option
                v-for="item in isPay"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="马甲号" style="margin-bottom: 0">
            <el-select
              v-model.number="params.isPretendAcc"
              placeholder="是否马甲账号"
              style="width: 100%"
              size="small"
              @change="getVideoList('status')"
              clearable
            >
              <el-option
                v-for="item in isVest"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="帖子类型" style="margin-bottom: 0">
            <el-select
              v-model.number="params.newsType"
              placeholder="帖子类型"
              style="width: 100%"
              size="small"
              @change="getVideoList('status')"
              clearable
            >
              <el-option label="全部" :value="0"></el-option>
              <el-option label="视频" :value="1"></el-option>
              <el-option label="图文帖" :value="2"></el-option>
              <el-option label="图集" :value="3"></el-option>
              <el-option label="黄游" :value="7"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="用户ID" style="margin-bottom: 0">
            <el-input
              v-model="params.uid"
              placeholder="请输入用户ID"
              size="small"
              class="param-input"
              @change="getVideoList('status')"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="3">
        <el-col :span="6">
          <el-form-item label="帖子ID" style="margin-bottom: 0">
            <el-input
              v-model="params.id"
              placeholder="请输入帖子ID"
              clearable
              @change="getVideoList('status')"
              size="small"
              class="param-input"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="帖子标题" style="margin-bottom: 0">
            <el-input
              v-model="params.title"
              placeholder="请输入帖子标题"
              size="small"
              class="param-input"
              @change="getVideoList('status')"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <div class="btn-wrapper">
            <el-button type="primary" size="small" @click="getVideoList()"
              >搜索</el-button
            >
            <el-button type="primary" size="small" @click="examine('many')"
              >批量审核</el-button
            >
            <el-button type="primary" size="small" @click="addVideo()"
              >+新增帖子</el-button
            >
            <el-button type="primary" size="small" @click="examineAll()"
              >查看当前列表所有帖子</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="openConfiguration('vid')"
              >审核不通过原因配置</el-button
            >
            <el-button type="primary" size="small"   @click="handleBatchRemoves(0)"
            >批量删除
            </el-button>
          </div>
        </el-col>
        <!-- <el-col :span="6"> </el-col> -->
      </el-row>
    </el-form>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      ref="multipleTable"
      v-loading="loading"
      size="small"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      @selection-change="handleSelectionChange"
      :row-style="rowStyle"
      @row-click="handleRowClick"
      highlight-current-row
      @sort-change="handleSortChange"
      height="100%"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="用户ID" align="center" width="80" fixed>
        <template slot-scope="scope">
          <span>{{ scope.row.publisher.uid || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        label="帖子ID"
        align="center"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="title"
        label="视频标题"
        show-overflow-tooltip
        width="260"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.title || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="summary"
        label="内容"
        show-overflow-tooltip
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.summary || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="subModuleName"
        label="子模块"
        align="center"
        width="90"
      ></el-table-column>
      <el-table-column
        prop="newsType"
        label="帖子类型"
        align="center"
        width="100"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.newsType === "SP"
              ? "视频帖子"
              : scope.row.newsType === "COVER"
              ? "图片帖子"
              : scope.row.newsType === "AD_SP"
              ? "视频广告"
              : scope.row.newsType === "BUTTER"
              ? "黄色游戏"
              : "图片广告"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="userName"
        label="用户昵称"
        align="center"
        width="100"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.publisher.name || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="userImage"
        label="用户头像"
        align="center"
        width="90"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <img-load
            :width="'30px'"
            :src="imgUrl + scope.row.publisher.portrait"
          ></img-load>
        </template>
      </el-table-column>
      <el-table-column label="封面图" align="center" width="90" prop="cover">
        <template slot-scope="scope">
          <img-load
            v-if="showImgLoad"
            :height="'30px'"
            :src="imgUrl + '/' + scope.row.cover"
          ></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="预览" align="center" width="50">
        <template slot-scope="scope" v-if="scope.row.sourceURL">
          <i
              class="el-icon-video-play views"
              title="点击预览"
              @click="checkMedia(scope.row.sourceURL, 'video', scope.row)"
          ></i>
        </template>
      </el-table-column>
      <el-table-column
        prop="seriesCover"
        label="图集预览"
        align="center"
        width="240"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.seriesCover || !scope.row.seriesCover.length"
            >未知</span
          >
          <div
            v-else
            class="picturePreview"
            @click="
              previewPicture(scope.row.seriesCover, scope.row.id, scope.row)
            "
          >
            <div v-if="showImgLoad" style="display: flex">
              <div
                v-for="(item, i) in scope.row.seriesCover"
                style="margin-right: 5px"
                :key="i"
              >
                <img-load-collection
                  height="30px"
                  :src="imgUrl + '/' + item"
                ></img-load-collection>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
       <el-table-column
        prop="createdAt"
        label="上传时间"
        align="center"
        width="160"
        :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="url" label="原视频下载" align="center" width="100">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="small"
            @click="downloadMedia(scope.row.id)"
            v-if="scope.row.newsType === 'SP'"
          >
            <i class="el-icon-download" title="原视频下载"></i>
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="是否为精选" align="center" width="120">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.chosen"
            @change="setChosen(scope.row, 'chosen')"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="size"
        label="视频大小(M)"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.size / 1024 / 1024) | transformFloat }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="playTime"
        label="总时长"
        align="center"
        width="130"
        :sortable="'custom'"
      >
        <template slot-scope="scope">{{
          scope.row.playTime | changeSecond
        }}</template>
      </el-table-column>
      <el-table-column
        prop="freeTime"
        label="免费时长"
        align="center"
        width="130"
        :sortable="'custom'"
      >
        <template slot-scope="scope">{{
          scope.row.freeTime | changeSecond
        }}</template>
      </el-table-column>
      <el-table-column
        prop="coins"
        label="价格"
        align="center"
        width="100"
        :sortable="'custom'"
      ></el-table-column>
      <el-table-column prop="tags" label="标签" align="center" min-width="420">
        <template slot-scope="scope">
          <el-tag
            type="success"
            size="mini"
            effect="plain"
            class="tags"
            v-for="(tag, i) in scope.row.tags"
            :key="i"
            >{{ "#" + tag.name }}</el-tag
          >
          <i
            class="el-icon-edit edit"
            @click="editTag(scope.row, scope.row.picture)"
          ></i>
        </template>
      </el-table-column>

      <el-table-column
        prop="status"
        label="当前状态"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">未审核</span>
          <span v-if="scope.row.status === 2">未通过</span>
        </template>
      </el-table-column>
      <el-table-column
        label="是否可推荐"
        align="center"
        width="100"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.recoWeight === 0 ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="220">
        <template slot-scope="scope">
          <!-- <el-tooltip class="item" effect="dark" content="审核" placement="top" v-if="userInfo.admin.role !== '公共资源'">
            <el-button type="success" size="mini" class="el-icon-check" @click="examineOne(scope.row)"></el-button>
          </el-tooltip>-->
          <el-button type="success" size="mini" @click="approved(scope.row.id)"
            >通过</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click="passButton(scope.row, 'vid')"
            >拒绝</el-button
          >
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="editVideo(scope.row)"
          >编辑</el-button>
          <!-- <el-button type="danger" size="mini" class="el-icon-delete" @click="removeVideo(scope.row.id)"></el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <div>
      <el-pagination
        :page-sizes="[5, 10, 15, 20, 50, 100]"
        :current-page="params.pageNumber"
        :page-size="params.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        @size-change="changeSize"
        @current-change="changeCurrent"
      ></el-pagination>
    </div>

    <!--封面图、视频弹窗组件-->
    <preview-video ref="previewVideo"></preview-video>
    <!--标签话题编辑弹窗-->
    <tags-popup
      ref="tagsPopup"
      @handlerVideoList="handlerVideoList"
    ></tags-popup>
    <!-- 审核不通过理由弹窗 -->
    <reason-action ref="reasonAction" />
    <!--批量审核弹窗-->
    <examine-popup
      ref="examinePopup"
      @handlerExamine="handlerExamine"
    ></examine-popup>
    <select-reason ref="selectReason" @handleList="getVideoList()" />
    <!--新增视频-->
    <add-video
      ref="addVideo"
      @handlerLoadList="handlerLoadList"
      v-if="showAddRef"
    ></add-video>
    <!-- 编辑视频 -->
    <edit-video ref="editVideo" @handlerEditList="handlerEditList"></edit-video>
    <!--审核当前界面所有视频-->
    <examine-all ref="examineAll"></examine-all>
    <!-- 图集预览窗口 -->
    <preview-picture
      ref="previewPicture"
      @handlerPreviewList="handlerPreviewList"
    ></preview-picture>
  </div>
</template>
<script>
import PreviewVideo from "./components/preview-video";
import TagsPopup from "./components/tags-popup";
import ExaminePopup from "./components/examine-popup";
import AddVideo from "./components/add-video.vue";
import EditVideo from "./components/edit-video";
import ExamineAll from "./components/examine-all";
import API from "@/api";
import {sortEscape} from "@/utils/global";
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";
import PreviewPicture from "./components/previewPicture";
import ReasonAction from "@/components/reasonAction";
import SelectReason from "@/components/selectReasonAction";

export default {
  data() {
    return {
      loading: false,
      total: 0,
      showImgLoad: false,
      showAddRef: false,
      imgUrl: baseConfig.imgUrl,
      userInfo: local.get("userInfo"),
      listUrl: [],
      // 请求列表查询
      params: {
        pageNumber: 1,
        pageSize: 15,
        status: 0,
        isFree: 2,
        isPretendAcc: 0,
        key: "createdAt",
        newsType: 0,
        value: "1",
        title: "",
        uid: "",
        id: "",
      },
      // 是否免费
      isPay: [
        {
          label: "全部",
          value: 2,
        },
        {
          label: "是",
          value: 0,
        },
        {
          label: "否",
          value: 1,
        },
      ],
      // 是否是马甲账号
      isVest: [
        {
          label: "所有",
          value: 0,
        },
        {
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 2,
        },
      ],
      // 被勾选(审核)的数据
      checkedData: [],
      // 列表数据
      tableData: [],
    };
  },
  components: {
    PreviewVideo,
    TagsPopup,
    ExaminePopup,
    AddVideo,
    EditVideo,
    ExamineAll,
    PreviewPicture,
    ReasonAction,
    SelectReason,
  },
  mounted() {
    this.getVideoList();
  },
  methods: {
    // 是否为精选
    setChosen(row, type) {
      if (type === "chosen") {
        // 视频精选
        row.chosen = !row.chosen;
        let text = row.chosen
          ? "您确定要取消当前视频的精选推送吗？"
          : "您确定要推送当前视频至精选吗？";
        this.$confirm(text, "推送提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let params = {
              ids: [row.id],
              field: "chosen",
              status: !row.chosen,
            };
            API.setChosen(params).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: params.status
                    ? "推送至精选成功！"
                    : "取消精选成功！",
                  type: "success",
                });
                this.getVideoList();
              } else {
                this.$message.error("推送至精选失败！");
              }
            });
          })
          .catch(() => {});
      }
    },
    handlerPreviewList() {
      this.getVideoList();
    },
    // 获取视频列表
    getVideoList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      this.showImgLoad = false;
      API.getVideoList(this.params)
        .then((res) => {
          this.showImgLoad = true;
          if (res.code === 200 && res.data.vInfos) {
            this.tableData = res.data.vInfos;
            this.total = res.data.total;
            if (this.listUrl.length > 0) {
              this.listUrl = [];
            }
            this.tableData.forEach((item) => {
              this.listUrl.push({ url: item.sourceURL, title: item.title });
            });
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // 下载原视频
    downloadMedia(id) {
      let param = {};
      API.videoFeviewList(param, id).then((res) => {
        let href = baseConfig.downLoadUrl + res.data.fileName;
        window.open(href);
      });
    },
    // 通过审核
    approved(id) {
      let params = {
        ids: [id],
        pass: 1,
        reason: "",
      };
      this.examineVideo(params);
    },
    // 审核请求
    examineVideo(params) {
      API.examineVideo(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("操作失败！");
          }
        })
        .catch(() => {
          this.$message.error("操作失败！");
        });
    },
    // 点击不通过按钮
    passButton(row, type) {
      this.$refs.selectReason.open(row, type);
    },
    // 图集预览
    previewPicture(pictureArr, id, item) {
      let Arr = JSON.parse(JSON.stringify(pictureArr));
      this.$refs.previewPicture.open(Arr, id, item);
    },
    // 获取不通过理由列表
    queryFailList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.reasonLoading = true;
      API.queryFailList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            res.data.list.forEach((item) => {
              item.isClisk = false;
            });
            this.reasonTableData = res.data.list;
            this.reasonTotal = res.data.total;
          } else {
            this.reasonTableData = [];
            this.reasonTotal = 0;
          }
          this.reasonLoading = false;
        })
        .catch(() => {
          this.reasonTableData = [];
          this.reasonLoading = false;
        });
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getVideoList();
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getVideoList();
    },
    // 新增视频成功回调
    handlerLoadList() {
      this.getVideoList();
    },
    // 编辑视频成功回掉
    handlerEditList() {
      this.getVideoList();
    },
    // 审核结果回调
    handlerExamine() {
      this.getVideoList();
    },
    // 不通过理由列表回掉
    handlerConfigurationList() {
      this.getVideoList();
    },
    // 排序回掉
    handleSortChange(column) {
      if (column.order) {
        this.params.value = sortEscape(column.order);
        this.params.key = column.prop;
      } else {
        this.params.value = "";
        this.params.key = "";
      }
      this.getVideoList();
    },
    // 监听标签编辑回调
    handlerVideoList() {
      this.getVideoList();
    },
    // 视频查看
    checkMedia(url, type, data) {
      const linkUrl = url.startsWith("/") ? url : "/" + url;
      this.$refs.previewVideo.open(linkUrl, type, data);
    },
    // 编辑标签
    editTag(row, pic) {
      this.$refs.tagsPopup.open(row, pic);
    },
    // 进行数据勾选时触发事件
    handleSelectionChange(row) {
      this.checkedData = row;
    },

    rowStyle({ row }) {
      if (this.checkData && this.checkData.length > 0) {
        return this.checkData.some((item) => item.id === row.id)
          ? { backgroundColor: "#f0ffff" }
          : {};
      } else {
        return {};
      }
    },

    handleRowClick(row, column, event) {
      const trDom = this.getTrDom(event.target);
      if (trDom) {
        var tbodyDom = trDom.parentElement;
        var trDoms = tbodyDom.children;
        for (let i = 0; i < trDoms.length; i++) {
          if (trDom != trDoms[i]) {
            trDoms[i].style.backgroundColor = "";
          }
        }
        if (trDom.style.backgroundColor) {
          trDom.style.backgroundColor = "";
        } else {
          trDom.style.backgroundColor = "rgba(245, 108, 108,0.2)";
        }
      }
    },

    getTrDom(dom) {
      if (dom.tagName.toLowerCase() == "tr") {
        return dom;
      }
      return this.getTrDom(dom.parentElement);
    },

    // 取消选择
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 点击审核
    examine(type) {
      if (type === "many" && this.checkedData.length === 0) {
        this.$message.error("请至少选择一条信息进行审核");
        return;
      }
      if (type === "many" && this.checkedData.length > 100) {
        this.$message.error("审核的条数不能超过100条");
        return;
      }
      let checkedData1 = JSON.parse(JSON.stringify(this.checkedData));
      this.$refs.examinePopup.open(checkedData1, type);
      this.toggleSelection();
    },
    // 点击审核
    batchDeletes(type) {
      if (type === "many" && this.checkedData.length === 0) {
        this.$message.error("请至少选择一条信息进行审核");
        return;
      }
      if (type === "many" && this.checkedData.length > 100) {
        this.$message.error("审核的条数不能超过100条");
        return;
      }
      let checkedData1 = JSON.parse(JSON.stringify(this.checkedData));
      this.$refs.examinePopup.open(checkedData1, type);
      this.toggleSelection();
    },
    // 单条审核
    // examineOne(row) {
    //   // 设置为空避免下次打开弹窗时会记录上次数据
    //   this.checkedData = []
    //   this.checkedData.push(row)
    //   this.examine('single')
    //   // 设置为空避免点击取消时会记录上次数据
    //   this.checkedData = []
    // },
    // 删除视频
    // removeVideo(id) {
    //   this.$confirm('您确定要删除当当前视频吗？', '删除提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     API.deleteVideo({ ids: [id] }).then(res => {
    //       if (res.code === 200) {
    //         this.$message({
    //           message: '删除成功',
    //           type: 'success'
    //         });
    //         this.getVideoList()
    //       } else {
    //         this.$message.error('删除失败！');
    //       }
    //     })
    //   })
    // },
    // 新增视频
    addVideo() {
      this.showAddRef = true;
      this.$nextTick(() => {
        this.$refs.addVideo.open();
      });
    },
    // 编辑视频
    editVideo(row) {
      // row.size = (row.size/1024/1024).toFixed(2)
      this.$refs.editVideo.open(row);
    },
    // 审核全部视频
    examineAll() {
      this.$refs.examineAll.open(this.listUrl);
    },
    // 审核不通过理由配置
    openConfiguration(type) {
      this.$refs.reasonAction.open(type);
    },
    handleBatchRemoves(status) {
      if (this.checkedData.length === 0) {
        this.$message.error("请选择需要批量删除的帖子");
        return false;
      }
      const ids = [];
      this.checkedData.forEach((item) => {
        ids.push(item.id);
      });

      const currentData = {
        ids,
        status: status, // 批量删除
      };

      var text = "高危操作，执行点击【确定】按钮?";
      var text2 = "是否批量删除当前选中帖子?"
      if (status == 1){
        text = "你确定执行批量恢复操作吗？";
        text2 = "是否批量恢复当前选中帖子？";
      }

      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(()=>{
        this.$confirm(text2, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(() => {
              API.batchModifyCoinAndRemoveSelf(currentData).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: "执行成功，如果误操作想恢复请联系技术处理！",
                    type: "success",
                  });
                  this.getVideoList();
                } else {
                  this.$message.error("执行失败！");
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "执行失败",
              });
            });

        this.checkData = [];
      })
    },
  },
};
</script>

<style lang="scss">
.videoExamine-box {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  padding-bottom: 6px;
  .views {
    font-size: 20px;
    color: #e63765;
    cursor: pointer;
    &:hover {
      color: #eb5f84;
    }
  }
  .edit {
    font-size: 18px;
    cursor: pointer;
    color: #e63765;
    vertical-align: middle !important;
    &:hover {
      color: #eb5f84;
    }
  }
  .cell {
    overflow: hidden;
  }
  .tags {
    font-size: 12px;
    margin-right: 5px;
  }
  .action-bar {
    // width: 100%;
    // // border: 1px solid red;
    // display: flex;
    // flex-wrap: wrap;
    // // height: 30px;
    // font-size: 14px;
    // color: #666;
    // // margin-bottom: 50px !important;
    .el-select {
      width: 200px;
      margin-right: 10px;
    }
    .el-button {
      margin-left: 10px;
    }
    .block {
      margin-top: 30px;
    }
    .param-input {
      width: 180px;
      margin-right: 10px;
    }
  }
  .picturePreview {
    max-width: 300px;
    display: flex;
  }
}
.btn-wrapper {
  margin-top: 4px;
  margin-left: 12px;
}
</style>
